import { atom } from "recoil";

export type NewsList = {
  news_id: number;
  news_title: string;
  title: string;
  url: string;
  published_date: string;
  content: string;
  description: string;
}[];

export const newsStore = atom<NewsList>({
  key: "newsStoreKey",
  default: [],
});
